export default {
  font: {
    main: 'montserrat',
    title: 'bitter',
    lineHeight: 1.69,
    size: {
      default: '1.5rem',
      small: '1rem',
    },
  },
  size: {
    headerHeight: '100px',
    footerHeight: '100px',
  },
  color: {
    text: '#93918f',
    dark: '#000000',
    midDark: '#636363',
    midLight: '#d5d5d5',
    light: '#ffffff',
  },
};
